const Typography = {
  titleWeight: '500',
}

module.exports = { Typography }
